import { Injectable } from '@angular/core';
import * as _ from 'lodash';

import { AppService } from 'app/app.service';
import { QueueStatusEnum } from 'app/enums';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InterviewService } from 'app/interview.service';
import { NotificationService, NotificationSeverity } from '@Services';
import { IllustrataDialogComponent } from '@Components/illustrata/illustrata-dialog.component';

@Injectable()
export class IllustrataIntegrationResponseHandler{
    dialogRef: MatDialogRef<IllustrataDialogComponent>;

    constructor(
        public appService: AppService,
        public interviewService: InterviewService,
        public notificationService: NotificationService,
        public dialog: MatDialog
    ) {}

    handleResponse(clientId: string, accountId: string,integrationResponse, integrationData){
        if (this.dialogRef && this.dialogRef != null) {
            return;
        }

        if (integrationResponse.status === QueueStatusEnum.Completed) {

            // if (error && error !== null && error !== '') {
            //     this.notificationService.showNotification({severity: NotificationSeverity.Error, message: error, log: true });
            //     return;
            // }

            this.showIllustrataEmbeddedDialog(clientId, accountId, integrationData.caseDetailId, integrationData.caseIntegrationQueueId, integrationData);
        }
    }

    showIllustrataEmbeddedDialog(clientId: string, accountId: string, caseId: string, caseIntegrationQueueId: string, integrationData) {
        const frameUrl = _.get(integrationData, 'details.clientProperties.frameUrl');

        this.dialogRef = this.dialog.open(IllustrataDialogComponent, {
            width: '60%',
            height: '90%',
            data: {
                clientId: clientId,
                caseId: caseId,
                caseIntegrationQueueId: caseIntegrationQueueId,
                frameUrl: frameUrl,
                accountId: accountId
            }
        });

        this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef = null;
        });
    }
}
